module.exports = __webpack_public_path__ + "img/leaf.36731ab4.svg";